module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Product or UPC",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.filters.product),
      callback: function($$v) {
        _vm.$set(_vm.filters, "product", $$v)
      },
      expression: "filters.product"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getList()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "Warehouse",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getList()
      }
    },
    model: {
      value: (_vm.filters.warehouse),
      callback: function($$v) {
        _vm.$set(_vm.filters, "warehouse", $$v)
      },
      expression: "filters.warehouse"
    }
  }, _vm._l((_vm.warehouseList), function(w, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": w.address + ' ' + w.city + ' ' + w.state,
        "value": w.warehouseNo
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "value-format": "yyyy-MM",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "to",
      "start-placeholder": "start",
      "end-placeholder": "end",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.exportExcel('/excel/exportStorageFee', 'StorageFee.xls')
      }
    }
  }, [_vm._v("Export")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "stripe": "",
      "data": _vm.list,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "warehouse",
      "label": "Warehouse"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "product_name",
      "label": "Product"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "upc",
      "label": "UPC"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "qty",
      "label": "Qty"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "Price"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_total",
      "label": "Fee"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.formatMoney(scope.row.charge_total, 2)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "charge_date",
      "label": "Date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318c8c70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/doctor/storageFee.vue
// module id = 779
// module chunks = 1